import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControlRemote } from '../../../../../shared/form/element/form-control-remote';

@Injectable()
export class CustomerLicenseForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      license: new FormControlRemote('id'),
      features: [ [], Validators.required ],
      printMode: [ 'staffed', Validators.required ],
      isBlocked: [ false ],
      hasPhotoBlocked: [ false ],
      hasPrintBlocked: [ false ],
    });
  }
}
